export default class Layoutgrid {
  constructor(categorySelect) {
    // 1. Create the button
    const button = document.createElement('button');
    button.className = 'js-toggle-layout-grid layout-grid__button';
    button.innerHTML = 'Show layout';

    // 2. Append somewhere
    const body = document.getElementsByTagName('body')[0];
    body.appendChild(button);

    // 3. Add event handler
    button.addEventListener('click', () => {
      if (body.classList.contains('show--layout-grid')) {
        body.classList.remove('show--layout-grid');
        button.innerHTML = 'Show layout';
      } else {
        body.classList.add('show--layout-grid');
        button.innerHTML = 'Hide layout';
      }
    });

    if (categorySelect) {
      const selectOptions = ['primary', 'secondary', 'tertiary'];

      // 1. Create the select
      const select = document.createElement('select');
      select.className = 'js-toggle-layout-category layout-category-select';
      for (let i = 0; i < selectOptions.length; i++) {
        const item = selectOptions[i];
        const option = document.createElement('option');
        option.innerHTML = item;
        option.value = item;
        if (body.classList.contains(`is--category--${item}`)) {
          option.selected = true;
        }
        select.appendChild(option);
      }

      // 2. Append somewhere
      body.appendChild(select);

      // 3. Add event handler
      select.addEventListener('change', () => {
        for (let i = 0; i < selectOptions.length; i++) {
          const item = selectOptions[i];
          body.classList.remove(`is--category--${item}`);
        }

        body.classList.add(`is--category--${select.value}`);
      });
    }
  }
}
